export interface ImportFileReponse {
    taskId: string;
    success: boolean;
}

export enum QueueJobStatus {
    Initialized = 1,
    InProgress = 2,
    Done = 3,

    Import_Parsed = 12,
    Import_Finished = 14,

    Import_Validate = 300,
    Import_ValidateError = 301,
    Import_ValidateWarning = 302,
    Import_Validate_WrongEncoding = 303,

    DuplicateKeys = 303,

    Completed = 100,

    RequestError = 101,
    Canceled = 102,
    ServerError = 500,

    // XLS Import
    Import_FileReceived = 1000,
    // AmazonUpload
    Import_AmazonUpload_Progress = 1100,
    Import_AmazonUpload_Failed = 1101,
    Import_AmazonUpload_Success = 1102,
    // Parse
    Import_Parse_Progress = 1200,
    Import_Parse_Failed = 1201,
    Import_Parse_Success = 1202,
    // Validate
    Import_Validate_Progress = 1300,
    Import_Validate_Failed = 1301,
    Import_Validate_Success = 1302,
    // Import
    Import_Import_Progress = 1400,
    Import_Import_Failed = 1401,
    Import_Import_Success = 1402,
}
export enum ProgressStopCode {
    None = 0,
    Success = 1,
    Warning = 2,
    Error = 3,
}
export class GetTaskProgressRequest {
    taskId: string = "";
    taskStatus: number = 0;
}

export class GetTaskProgressResponse {
    error: string = "";
    errorCode: number = 0;
    id: string = "";
    status: number = 0;
    progress: number = 0;
    stopCode: number = 0;
    stopMessage: string = "";
    reportUrl: string = "";
}

export interface GetTaskInfoResponse {
    error: string;
    errorMessage: string;
    id: string;
    status: number;
    step: number;
    progress: number;
    currentMsg: string;
    columnNames: Dictionary<string>;
    reportUrl: string;
    isRefdataInserted: boolean;
}
export type Dictionary<T> = { [key: string]: T };
export class ValidateImportRequest {
    TaskId: string = "";
    Mapping: Dictionary<string> = { "": "" };
    UniqueKeyColumn: string = "";
}
export interface ImportValidationResponse {
    Error: string;
    TaskId: string;
}
export class SaveProfileRequest {
    name: string = "";
    queueJobId: string = "";
}
export interface SaveProfileResponse {
    error: string;
    errorMessage: string;
}
export class NewGroupRequest {
    Name: string = "";
}
export class NewGroupResponse {
    id: string = "";
    error: string = "";
}
